import React from "react";
import { useContext, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { Context, classDataPath } from "../../../teacherStore";
import Button from "../../../atoms/ActiveLearning/Button";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import Lesson1 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson1";
import Lesson2 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson2";
import Lesson3 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson3";
import Lesson4 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson4";
import Lesson5 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson5";
import Lesson6 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson6";
import Lesson7 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson7";
import Lesson8 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson8";
import Lesson9 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson9";
import Lesson10 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson10";
import Lesson11 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson11";
import Lesson12 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson12";
import Lesson13 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson13";
import Lesson14 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson14";
import Lesson15 from "../../../organisms/teacher/ActiveLearningLessonAnswerData/Lesson15";
import { ReactComponent as IconArrowDown } from "../../../assets/images/ActiveLearning/icon_arrow_down.svg";

import styles from "./ActiveLearningClassDataContents.module.scss";

export const ActiveLearningClassDataContents = () => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;
  const [materialCode, setMaterialCode] = useState("ECS001");

  const LessonComponentsRound1 = [
    {
      no: "01",
      component: <Lesson1 materialCode={materialCode} lessonNo={1} />,
    },
    {
      no: "02",
      component: <Lesson2 materialCode={materialCode} lessonNo={2} />,
    },
    {
      no: "03",
      component: <Lesson3 materialCode={materialCode} lessonNo={3} />,
    },
    {
      no: "04",
      component: <Lesson4 materialCode={materialCode} lessonNo={4} />,
    },
    {
      no: "05",
      component: <Lesson5 materialCode={materialCode} lessonNo={5} />,
    },
    {
      no: "06",
      component: <Lesson6 materialCode={materialCode} lessonNo={6} />,
    },
    {
      no: "07",
      component: <Lesson7 materialCode={materialCode} lessonNo={7} />,
    },
    {
      no: "08",
      component: <Lesson8 materialCode={materialCode} lessonNo={8} />,
    },
    {
      no: "09",
      component: <Lesson9 materialCode={materialCode} lessonNo={9} />,
    },
    {
      no: "10",
      component: <Lesson10 materialCode={materialCode} lessonNo={10} />,
    },
    {
      no: "11",
      component: <Lesson11 materialCode={materialCode} lessonNo={11} />,
    },
  ];
  const LessonComponentsRound2 = [
    {
      no: "01",
      component: <Lesson1 materialCode={materialCode} lessonNo={1} />,
    },
    {
      no: "02",
      component: <Lesson12 materialCode={materialCode} lessonNo={2} />,
    },
    {
      no: "03",
      component: <Lesson13 materialCode={materialCode} lessonNo={3} />,
    },
    {
      no: "04",
      component: <Lesson14 materialCode={materialCode} lessonNo={4} />,
    },
    {
      no: "05",
      component: <Lesson4 materialCode={materialCode} lessonNo={5} />,
    },
    {
      no: "06",
      component: <Lesson5 materialCode={materialCode} lessonNo={6} />,
    },
    {
      no: "07",
      component: <Lesson6 materialCode={materialCode} lessonNo={7} />,
    },
    {
      no: "08",
      component: <Lesson7 materialCode={materialCode} lessonNo={8} />,
    },
    {
      no: "09",
      component: <Lesson8 materialCode={materialCode} lessonNo={9} />,
    },
    {
      no: "10",
      component: <Lesson9 materialCode={materialCode} lessonNo={10} />,
    },
    {
      no: "11",
      component: <Lesson10 materialCode={materialCode} lessonNo={11} />,
    },
    {
      no: "12",
      component: <Lesson15 materialCode={materialCode} lessonNo={12} />,
    },
  ];

  const lessonList = useMemo(() => {
    const selectedLessonComponents =
      materialCode === "ECS001"
        ? LessonComponentsRound1
        : LessonComponentsRound2;
    return selectedLessonComponents;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialCode]);

  const links = [
    {
      name: `クラスデータ`,
      to: classDataPath,
      search: "?isActiveLearning=true",
    },
    {
      name: `${activeLearningStudentAnswers?.last_name}${activeLearningStudentAnswers?.first_name}`,
      to: "#",
    },
  ];

  return (
    <div className={styles.wrapper}>
      <TeacherHeader links={links} />
      <div className={styles.header}>
        <div className={styles.inner}>
          <Link
            className={styles.return}
            to={`${classDataPath}?isActiveLearning=true`}
          >
            くクラス選択に戻る
          </Link>
          <ul className={styles.roundList}>
            <li className={styles.round}>
              <Button
                variant={materialCode === "ECS001" ? "primary" : "secondary"}
                width={"240px"}
                height={"40px"}
                fontSize={"14px"}
                handleClick={() => setMaterialCode("ECS001")}
              >
                1周目
              </Button>
            </li>
            <li className={styles.round}>
              <Button
                variant={materialCode === "ECS002" ? "primary" : "secondary"}
                width={"240px"}
                height={"40px"}
                fontSize={"14px"}
                handleClick={() => setMaterialCode("ECS002")}
              >
                2周目
              </Button>
            </li>
          </ul>
          <ul className={styles.anchorList}>
            {lessonList.map(lesson => (
              <li key={`lesson${lesson.no}`} className={styles.anchor}>
                <a href={`#lesson${lesson.no}`}>
                  <Button
                    variant={"secondary"}
                    width={"103px"}
                    height={"34px"}
                    fontSize={"12px"}
                  >
                    {`Lesson${lesson.no}`}
                    <IconArrowDown />
                  </Button>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <ul className={styles.lessonList}>
        {lessonList.map(lesson => (
          <li
            key={`lesson${lesson.no}`}
            id={`lesson${lesson.no}`}
            className={styles.lesson}
          >
            {lesson.component}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default ActiveLearningClassDataContents;
